import { vuexEventPathGenerator } from '@/utils';
import baseDomain, { actionType as baseActionType } from './action/base';
import orderDomain, { actionType as orderActionType } from './action/order';
import workerDomain, { actionType as workerActionType } from './action/worker';
import storeDomain, { actionType as storeActionType } from './action/store';
export const mapControlActionType = vuexEventPathGenerator({
    ...baseActionType,
    ...orderActionType,
    ...workerActionType,
    ...storeActionType,
}, 'mapControl');
export default {
    ...baseDomain,
    ...orderDomain,
    ...workerDomain,
    ...storeDomain,
};
